exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".images img[data-v-76be9c92]{padding:5px}", ""]);

// exports
